import { BlockSchema } from "bocknoat-core";
import { BlockColorsButton } from "./DefaultButtons/BlockColorsButton";
import { RemoveBlockButton } from "./DefaultButtons/RemoveBlockButton";
import { DragHandleMenu, DragHandleMenuProps } from "./DragHandleMenu";

export const DefaultDragHandleMenu = <BSchema extends BlockSchema>(
  props: DragHandleMenuProps<BSchema>
) => (
  <DragHandleMenu>
    <RemoveBlockButton {...props}>Delete</RemoveBlockButton>
    <BlockColorsButton {...props}>Colors</BlockColorsButton>
  </DragHandleMenu>
);
